import type { EfGroupClass } from '@form-factory/schema/contracts';
import type { StateCreator } from 'zustand';

export interface GroupClassSlice {
  groupClasses: {
    currentDate: Date;
    setCurrentDate: (date: Date) => void;
    currentClubId: string | undefined;
    setCurrentClubId: (clubId: string | undefined) => void;
    current: EfGroupClass | null;
    setCurrent: (groupClass: EfGroupClass | null) => void;
  };
}

export const createGroupClassSlice: StateCreator<GroupClassSlice> = (
  set,
  get,
) => ({
  groupClasses: {
    currentDate: new Date(),
    setCurrentDate: date =>
      set({
        groupClasses: { ...get().groupClasses, currentDate: date },
      }),
    currentClubId: undefined,
    setCurrentClubId: clubId =>
      set({
        groupClasses: { ...get().groupClasses, currentClubId: clubId },
      }),
    current: null,
    setCurrent: groupClass =>
      set({
        groupClasses: { ...get().groupClasses, current: groupClass },
      }),
  },
});
